import React, { useState } from 'react';

import { IsListEmpty, IsStringEmpty } from '../../utilities/CommonMethods';

import classes from './ModuleDetailsSidebar.module.css';
import Arrow from '../../assets/icons/SideBarArrow.svg';
import SubMenuArrow from '../../assets/icons/right-icon-solid-black.svg';
import { Link } from 'react-router-dom';
import RouteEndPoints from '../../utilities/RouteEndPoints';

const ModuleDetailsSidebar = (props) => {
    const [show, setShow] = useState(props.show);
    const navigationItemsList = !IsListEmpty(props.navigationItems)
        ? props.navigationItems.map((navigationItem, index) => {
            return <li key={index}
                className={[classes.NavigationItem, props.activeType === index ? classes.Active : null].join(' ')}
                onClick={() => props.onNavigationItemClick(index)}>
                {!IsStringEmpty(navigationItem.label) ? navigationItem.label : navigationItem.title}
                {
                    (index === 1 || index === 3) && props.forOverviewPage
                        ? <img src={SubMenuArrow} alt="Arrow" className={classes.SubMenuArrow} />
                        : null
                }
            </li>
        }) : null;

    return (
        <>
            <div className={[classes.ModuleDetailsSidebarContainer, show && props.show ? null : classes.Hide, classes.scroller, classes.topBar, props.solidBackground ? classes.SolidBg : ''].join(' ')}>
                <Link to={
                    props.forOverviewPage ? RouteEndPoints.PROGRAMS_PAGE + '/' + props.breadCrumb + '/overview'
                        : RouteEndPoints.PROGRAMS_PAGE + '/' + props.batchCode + '/modules/' + encodeURIComponent(props.breadCrumb) + '/performance'
                } className={classes.BreadCrumb} onClick={props.onBreadCrumbClick}>
                    {props.breadCrumb + ' >'}
                </Link>
                <div className={classes.HeadingContainer}>
                    {
                        props.forOverviewPage && !IsStringEmpty(props.logo)
                            ? <img src={props.logo} alt="Arrow" className={classes.ModuleLogo} />
                            : null
                    }
                    <h3 className={classes.Heading}>
                        {props.heading}
                    </h3>
                    <img src={Arrow} alt="Show/Hide" className={classes.Visible} onClick={() => [setShow(!show), props.handleShowHide(show)]} />
                </div>


                <ul className={classes.NavigationList}>
                    {navigationItemsList}
                </ul>
            </div>
            {<img src={Arrow} alt="Show/Hide" className={[classes.Hidden, show && props.show ? null : classes.HiddenArrow, classes.topBarArrow].join(' ')} onClick={() => [setShow(!show), props.handleShowHide(show)]} />
            }
        </>
    );
}

export default ModuleDetailsSidebar;